import './app';
import './forecast/check/forecastBettingArea';
import './forecast/table/forecastBettingArea';
import './greyhoundRacesUI';
import './greyhoundRacesUiService';
import './racecardBettingArea';
import './tricastBettingArea';

export default 'terminalApp.nabGreyhoundRacesUi';
